import { type PropsWithChildren, useMemo, useState } from 'react'
import {
  DocumentPaneContext,
  type DocumentPaneState,
  type DocumentPaneTab,
  type DocumentPaneTarget,
} from './document-pane-context'

export function DocumentPaneProvider({ children }: PropsWithChildren) {
  const [tab, setTab] = useState<DocumentPaneTab>('pdf')
  const [isOpen, setIsOpen] = useState(true)
  const [target, setTarget] = useState<DocumentPaneTarget | null>(null)

  const value = useMemo<DocumentPaneState>(
    () => ({
      tab,
      setTab,
      isOpen,
      setIsOpen,
      target,
      showQuote: (text, { isSearch = false } = {}) => {
        setIsOpen(true)
        setTab('text')
        setTarget({ kind: 'quote', text, isSearch, id: Date.now() })
      },
      showPage: (page) => {
        setIsOpen(true)
        setTarget({ kind: 'page', page, id: Date.now() })
      },
    }),
    [tab, isOpen, target],
  )

  return <DocumentPaneContext.Provider value={value}>{children}</DocumentPaneContext.Provider>
}
